import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { VerticalNaaService } from 'src/app/vertical/naa/shared/vertical-naa.service';
import { NaaProfileTypeManagementCompanyDto } from 'src/app/vertical/naa/shared/dto/naa-profile-type-management-company.dto';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'wl-profile-type-management-company-edit',
  templateUrl: './profile-type-management-company-edit.component.html',
  styleUrls: ['./profile-type-management-company-edit.component.less'],
    standalone: false
})
export class ProfileTypeManagementCompanyEditComponent implements OnInit, OnChanges {
  @Input() profileId: number;
  @ViewChild('overrideForm') overrideForm: NgForm;
  managementCompanyDto: NaaProfileTypeManagementCompanyDto;
  unitsInPortfolioOverride: number;

  constructor(private _verticalNaaService: VerticalNaaService) {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.profileId) {
      this._verticalNaaService.getProfileTypeManagementCompanyForProfileId(this.profileId).then((managementCompanyDto) => {
        this.managementCompanyDto = managementCompanyDto;
        this.unitsInPortfolioOverride = managementCompanyDto.TotalUnitsInPortfolio;
        this.managementCompanyDto.ProfileId = this.profileId;
      });
    }
  }

  overrideChanged() {
    this.managementCompanyDto.TotalUnitsInPortfolioOverridden =
      this.unitsInPortfolioOverride !== this.managementCompanyDto.TotalUnitsInPortfolio;
  }

  public save() {
    let promise: Promise<number | void>;
    if (this.managementCompanyDto.TotalUnitsInPortfolioOverridden) {
      this.managementCompanyDto.TotalUnitsInPortfolio = this.unitsInPortfolioOverride;
    }
    if (this.managementCompanyDto.Id > 0 && this.overrideForm?.dirty) {
      promise = this._verticalNaaService.updateProfileTypeManagementCompany(this.managementCompanyDto);
    } else if (this.managementCompanyDto.Id === 0) {
      promise = this._verticalNaaService.createProfileTypeManagementCompany(this.managementCompanyDto);
    } else {
      promise = Promise.resolve();
    }
    this.overrideForm?.form.markAsPristine();
    return promise;
  }
}
